const mediaVideos = document.querySelectorAll('[data-media-video]')

mediaVideos.forEach(media => {
  media.addEventListener('click', e => playVideo(media))
  media.addEventListener('keyup', e => e.keyCode === 13 && playVideo(media))
})

function playVideo (media) {
  const overlay = media.querySelector('.media__overlay')
  const thumbnail = media.querySelector('.media__thumbnail')
  const video = media.querySelector('.media__video')
  const dataSrc = video.getAttribute('data-src')

  if(overlay && thumbnail) {
    overlay.classList.add('hide')
    thumbnail.classList.add('hide')
  }

  video.setAttribute('src', dataSrc + '&autoplay=true')
}